import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Modal } from 'reactstrap';

import { hideModal } from '../actions';

import { isCustomPage } from '../helpers/App';

import CollectionEditModal from './Collections/EditModalV2';
import CollectionSelectModal from './Collections/SelectModalV2';
import CollectionsMoveModal from './Collections/MoveModalV2';
import CollectionDuplicateModal from './Collections/DuplicateModal';
import CollectionGroupEditModal from './CollectionGroups/EditModal';
import ShareModal from './Share/Modal';
import ChangeOwnerModal from './ChangeOwnerModal';
import LikesModal from './LikesModal';
import AccessModal from './Access/Modal';
import DownloadModal from './Download/Modal';
import StatusModal from './File/StatusModal';
import WatermarkedModal from './File/WatermarkedModal';
import CollectionGroupDeleteModal from './Admin/CollectionGroups/DeleteModal';
import CollectionGroupSelectModal from './Admin/CollectionGroups/SelectModal';
import CollectionGroupGroupEditModal from './Admin/CollectionGroupGroups/EditModal';
import GroupEditModal from './Admin/Groups/EditModal';
import UserDeactivateModal from './Admin/Users/DeactivateModal';
import UserActivateModal from './Admin/Users/ActivateModal';
import UserEditModal from './Admin/Users/EditModal';
import TermEditModal from './Admin/Terms/EditModal';
import TermMoveModal from './Admin/Terms/MoveModal';
import TermsImportModal from './Admin/Terms/ImportModal';
import FileStatusEditModal from './Admin/FileStatuses/EditModal';
import FileSizeEditModal from './Admin/FileSizes/EditModal';
import ArchiveModal from './ArchiveModal';
import FileDiffModal from './File/DiffModal';
import ShareLinksModal from './Shares/LinksModal';
import FileSelectModal from './FileSelectModal';
import AddUrlModal from './Upload/AddUrlModal';
import ImporterModal from './Importer/Modal';
import MoveItemsModal from './MoveItemsModal';
import FileMergeModal from './Admin/Duplicates/FileMergeModal';
import BulkMergeModal from './Admin/Duplicates/BulkMergeModal';
import FTPAccountEditModal from './Admin/FTPAccounts/EditModal';
import UploadPageEditModal from './Admin/UploadPages/EditModal';
import ImageEditorModal from './ImageEditorModal';
import ImageEditorPresetEditModal from './Admin/Settings/ContentSections/ImageEditor/ImageEditorPresetEditModal';
import CommentsCopyModal from './File/CommentsCopyModal';
import MetadataMappingInsertFieldModal from './Admin/Settings/ContentSections/Advanced/Metadata/MetadataMappingInsertFieldModal';
import RemoveModal from './Collections/RemoveModal';
import PinSearchModal from './Search/PinSearchModal';
import TrialModal from './Admin/TrialModal';
import G2ReviewModal from './G2ReviewModal';
import AdminPanelAccountsEditModal from './AdminPanel/Accounts/EditModal';
import AdminPanelAccountsDeleteModal from './AdminPanel/Accounts/DeleteModal';
import DashboardPersonalizeModal from './Dashboard/Personalize/PersonalizeModal';
import UploadModal from './Upload/Modal';
import VideoPlayerModal from './VideoPlayerModal';
import OnboardingFinishedModal from './Dashboard/Onboarding/OnboardingFinishedModal';
import BulkVersioningModal from './BulkVersioning/Modal';
import DesignPickleRequestModal from './Integrations/Modals/DesignPickleRequestModal';
import ChangePersonModal from './ChangePersonModal';
import EditPersonNameModal from './EditPersonNameModal';
import TermsModal from './TermsModal';
import DownloadReasonsModal from './Download/ReasonsModal';
import SyncModal from './Collections/SyncModal';
import CollectionRestoreModal from './Collections/RestoreModal';
import EmptyTrashModal from './Files/EmptyTrashModal';
import MetadataGroupModal from './MetadataGroupModal';
import AdminPageCreateModal from './Admin/PageEdit/NewPageSetupModal';
import ExportModal from './ExportModal';

import { getSetting } from '../helpers/Settings';

const MODAL_COMPONENTS = {
  CollectionEditModal,
  CollectionSelectModal,
  CollectionsMoveModal,
  CollectionDuplicateModal,
  CollectionGroupEditModal,
  ShareModal,
  ChangeOwnerModal,
  LikesModal,
  AccessModal,
  DownloadModal,
  StatusModal,
  WatermarkedModal,
  CollectionGroupDeleteModal,
  CollectionGroupSelectModal,
  CollectionGroupGroupEditModal,
  GroupEditModal,
  UserDeactivateModal,
  UserActivateModal,
  UserEditModal,
  TermEditModal,
  TermMoveModal,
  TermsImportModal,
  FileStatusEditModal,
  FileSizeEditModal,
  ArchiveModal,
  FileDiffModal,
  ShareLinksModal,
  FileSelectModal,
  AddUrlModal,
  ImporterModal,
  MoveItemsModal,
  FileMergeModal,
  BulkMergeModal,
  FTPAccountEditModal,
  UploadPageEditModal,
  ImageEditorModal,
  ImageEditorPresetEditModal,
  CommentsCopyModal,
  MetadataMappingInsertFieldModal,
  RemoveModal,
  PinSearchModal,
  TrialModal,
  G2ReviewModal,
  AdminPanelAccountsEditModal,
  AdminPanelAccountsDeleteModal,
  DashboardPersonalizeModal,
  UploadModal,
  VideoPlayerModal,
  OnboardingFinishedModal,
  BulkVersioningModal,
  DesignPickleRequestModal,
  ChangePersonModal,
  EditPersonNameModal,
  TermsModal,
  DownloadReasonsModal,
  SyncModal,
  CollectionRestoreModal,
  EmptyTrashModal,
  MetadataGroupModal,
  AdminPageCreateModal,
  ExportModal,
};

class ModalRoot extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };

    this.handleClose = this.handleClose.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { modal } = this.props;

    if (modal && !prevProps.modal) {
      this.setOpenState(true);
    }
  }

  setOpenState(open) {
    this.setState({ open });
  }

  handleClose(e) {
    if (e) {
      e.persist();
    }

    const { modalProps } = this.props;

    if (modalProps.beforeClose) {
      modalProps.beforeClose();
    }

    if (e && e.target.href && e.target.href.indexOf('#') > -1) {
      e.preventDefault();
    }

    this.setState({ open: false });

    if (modalProps.afterClose) {
      modalProps.afterClose();
    }
  }

  render() {
    const {
      modal,
      modalProps,
      dispatch,
    } = this.props;
    const { open } = this.state;

    const onCustomPage = isCustomPage();

    if (!modal) {
      return null;
    }

    const ModalContent = MODAL_COMPONENTS[modal];
    return (
      <Modal
        isOpen={open}
        toggle={this.handleClose}
        className={
          classnames(
            modalProps.className,
            {
              cs1: getSetting('cs1'),
              'modal-custom-page': onCustomPage,
            },
          )
        }
        backdrop={modalProps.backdrop || 'static'}
        onOpened={() => {
          // Workaround for Reactstrap not adding 'modal-open' class on re-opening modal
          if (!window.$('body').hasClass('modal-open')) {
            window.$('body').addClass('modal-open');
          }
        }}
        onClosed={() => {
          dispatch(hideModal());
          this.setState({ open: false });
        }}
        autoFocus={false}
      >
        <ModalContent
          handleClose={this.handleClose}
          {...modalProps}
        />
      </Modal>
    );
  }
}

ModalRoot.propTypes = {
  dispatch: PropTypes.func.isRequired,
  modal: PropTypes.string,
  modalProps: PropTypes.object.isRequired,
  beforeClose: PropTypes.func,
  afterClose: PropTypes.func,
};

ModalRoot.defaultProps = {
  modal: null,
  beforeClose: () => {},
  afterClose: () => {},
};

export default connect(state => state.App)(ModalRoot);
